import { motion } from "framer-motion";
import { EASING, DURATION } from "@/lib/motionSystem";

export default function ScrollReveal({
  children,
  className = "",
  delay = 0,
  y = 24,
  once = true,
  amount = 0.25,
  as: Tag = motion.div,
  ...props
}) {
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{
        duration: DURATION.sectionReveal,
        delay,
        ease: EASING.smooth,
      }}
      {...props}
    >
      {children}
    </Tag>
  );
}
